import { useLingui } from "@lingui/react/macro";
import { Skeleton } from "@orbin/ui-web";

/**
 * A whole-page wait, drawn as the shell it is about to become: a roster beside a thread and a
 * composer. It fades in late, so a quick load paints nothing in between.
 */
export function PageLoading(props: React.ComponentPropsWithoutRef<"div">) {
  const { t } = useLingui();
  return (
    <div
      role="status"
      aria-label={t`Loading…`}
      className="flex h-full bg-background animate-in fade-in-0 fill-mode-both delay-500 duration-300 motion-reduce:animate-none"
      {...props}
    >
      <div
        aria-hidden="true"
        className="hidden w-72 shrink-0 flex-col gap-3 border-e border-sidebar-border bg-sidebar p-3 md:flex"
      >
        <div className="flex items-center gap-3 px-2 py-2.5">
          <Skeleton className="size-12 rounded-full" />
          <div className="flex flex-1 flex-col gap-2">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-3 w-32" />
          </div>
        </div>
        {[0, 1, 2].map((row) => (
          <div key={row} className="flex items-center gap-3 px-2 py-2">
            <Skeleton className="size-9 rounded-full" />
            <div className="flex flex-1 flex-col gap-2">
              <Skeleton className="h-3.5 w-24" />
              <Skeleton className="h-3 w-36" />
            </div>
          </div>
        ))}
      </div>
      <div aria-hidden="true" className="flex min-w-0 flex-1 flex-col justify-end gap-3 p-5">
        <Skeleton className="h-10 w-2/5 self-end rounded-[20px]" />
        <Skeleton className="h-16 w-3/5 rounded-[20px]" />
        <Skeleton className="mx-auto mt-4 h-12 w-full max-w-3xl rounded-full" />
      </div>
    </div>
  );
}
